import React, { useEffect, useState, useRef } from 'react'
import ComunicacaoControleService from "../../../services/ComunicacaoControleService"
import ComunicacaoBox from '../../../components/data_display/ComunicacaoBox'
import { ComunicacoesBox } from './styles'
import { useSnackbar } from "notistack"
import { useReactToPrint } from 'react-to-print';
import LogoTce from '../../../assets/img/logo-tcego.svg'
import { isNullReturnHyphen, DateFormat } from "../../../functions"
import Paginacao from '../../../components/data_display/Paginacao'
import { useAuth } from 'react-oidc-context'
import EnumEtapasComunicacao from '../../../enums/enumEtapasComunicacao'
import webconfig from "../../../webconfig.json"

export default function Comunicacoes(
    etapaComunicacao,
    titulo,
    recarregarComunicacoes,
    setRecarregarComunicacoes,
    idOrgaoJurisdicionado
) {
    const auth = useAuth()

    const [pagina, setPagina] = useState(1)
    const [qtdePagina, setQtdePagina] = useState(5)
    const [totalPagina, setTotalPagina] = useState(1)
    const [comunicacoes, setComunicacoes] = useState([])

    const [comunicacoesPrint, setComunicacoesPrint] = useState([])

    const [loadingCsv, setLoadingCsv] = useState(false)
    const [loadingPdf, setLoadingPdf] = useState(false)

    const [etapaPendenteCienciaLoading, setEtapaPendenteCienciaLoading] = useState(false)
    const [etapaPendenteRespostaLoading, setEtapaPendenteRespostaLoading] = useState(false)
    const [etapaPendenteTriagemLoading, setEtapaPendenteTriagemLoading] = useState(false)
    const [etapaPendenteLiberacaoLoading, setEtapaPendenteLiberacaoLoading] = useState(false)
    const [etapaRespondidaEncerradaLoading, setEtapaRespondidaEncerradaLoading] = useState(false)

    const { enqueueSnackbar } = useSnackbar()

    const componentRef = useRef();

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: 'Visitor Pass',
    });

    const getComunicacoes = () => {
        if (idOrgaoJurisdicionado !== undefined &&
            idOrgaoJurisdicionado !== null &&
            idOrgaoJurisdicionado !== 0 && (
                (etapaComunicacao === EnumEtapasComunicacao.PendenteCiencia && etapaPendenteCienciaLoading === false) ||
                (etapaComunicacao === EnumEtapasComunicacao.PendenteResposta && etapaPendenteRespostaLoading === false) ||
                (etapaComunicacao === EnumEtapasComunicacao.PendenteTriagem && etapaPendenteTriagemLoading === false) ||
                (etapaComunicacao === EnumEtapasComunicacao.PendenteLiberacao && etapaPendenteLiberacaoLoading === false) ||
                (etapaComunicacao === EnumEtapasComunicacao.RespondidaEncerrada && etapaRespondidaEncerradaLoading === false))) {
            if (etapaComunicacao === EnumEtapasComunicacao.PendenteCiencia) { setEtapaPendenteCienciaLoading(true) }
            if (etapaComunicacao === EnumEtapasComunicacao.PendenteResposta) { setEtapaPendenteRespostaLoading(true) }
            if (etapaComunicacao === EnumEtapasComunicacao.PendenteTriagem) { setEtapaPendenteTriagemLoading(true) }
            if (etapaComunicacao === EnumEtapasComunicacao.PendenteLiberacao) { setEtapaPendenteLiberacaoLoading(true) }
            if (etapaComunicacao === EnumEtapasComunicacao.RespondidaEncerrada) { setEtapaRespondidaEncerradaLoading(true) }

            ComunicacaoControleService.ConsultaPorEtapaComunicacao(idOrgaoJurisdicionado, etapaComunicacao, pagina, qtdePagina)
                .then(response => {
                    setComunicacoes(response.data.comunicacoes)
                    setTotalPagina(response.data.totalPaginas)
                })
                .catch(error => {
                    if (error.response && error.response.data) {
                        if (error.response.status === 422) {
                            enqueueSnackbar(`${error.response.data.detail}`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                        }
                        else if (error.response.status === 500) {
                            enqueueSnackbar(`Ocorreu um erro inesperado. Contate o suporte (${error.response.data.detail})`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                        }
                        else {
                            enqueueSnackbar(`${error.response.data.detail}`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                        }
                    }
                    else {
                        enqueueSnackbar(`Ocorreu um erro inesperado. Contate o suporte (${error.message})`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                })
                .finally(() => {
                    if (etapaComunicacao === EnumEtapasComunicacao.PendenteCiencia) { setEtapaPendenteCienciaLoading(false) }
                    if (etapaComunicacao === EnumEtapasComunicacao.PendenteResposta) { setEtapaPendenteRespostaLoading(false) }
                    if (etapaComunicacao === EnumEtapasComunicacao.PendenteTriagem) { setEtapaPendenteTriagemLoading(false) }
                    if (etapaComunicacao === EnumEtapasComunicacao.PendenteLiberacao) { setEtapaPendenteLiberacaoLoading(false) }
                    if (etapaComunicacao === EnumEtapasComunicacao.RespondidaEncerrada) { setEtapaRespondidaEncerradaLoading(false) }
                })
        }
    }

    const exportaCsv = () => {
        setLoadingCsv(true)
        ComunicacaoControleService.ExportaCsv(etapaComunicacao, idOrgaoJurisdicionado)
            .then(response => {
                if (response.status === 200) {
                    let extensionFile = response.data.tipoArquivo
                    let a = document.createElement("a")
                    a.href = `data:${extensionFile};base64,${response.data.conteudo}`
                    a.download = response.data.nomeArquivo
                    a.click()

                    enqueueSnackbar('Download realizado com sucesso', { variant: 'success', autoHideDuration: webconfig.snackbarAutoHideDuration })
                    setLoadingCsv(false)
                }
                else {
                    enqueueSnackbar('Não foi possível fazer donwload do arquivo CSV. Contate o suporte.', { variant: 'error', autoHideDuration: webconfig.snackbarAutoHideDuration })
                }
            })
            .catch(error => {
                setLoadingCsv(false)
                if (error.response && error.response.data) {
                    if (error.response.status === 422) {
                        enqueueSnackbar(`${error.response.data.detail}`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                    else if (error.response.status === 500) {
                        enqueueSnackbar(`Ocorreu um erro inesperado. Contate o suporte (${error.response.data.detail})`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                    else {
                        enqueueSnackbar(`${error.response.data.detail}`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                }
                else {
                    enqueueSnackbar(`Ocorreu um erro inesperado. Contate o suporte (${error.message})`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                }
            })
    }

    const exportPdf = () => {
        ComunicacaoControleService.ConsultaPorEtapaComunicacao(idOrgaoJurisdicionado, etapaComunicacao, 1, 1000000)
            .then(response => {
                setComunicacoesPrint(response.data.comunicacoes)
                handlePrint()
            })
            .catch(error => {
                if (error.response && error.response.data) {
                    if (error.response.status === 422) {
                        enqueueSnackbar(`${error.response.data.detail}`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                    else if (error.response.status === 500) {
                        enqueueSnackbar(`Ocorreu um erro inesperado. Contate o suporte (${error.response.data.detail})`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                    else {
                        enqueueSnackbar(`${error.response.data.detail}`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                }
                else {
                    enqueueSnackbar(`Ocorreu um erro inesperado. Contate o suporte (${error.message})`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                }
            })
    }

    useEffect(() => {
        getComunicacoes()
    }, [pagina, qtdePagina, recarregarComunicacoes])

    class ComunicacaoPrint extends React.Component {
        render() {
            return (
                <ComunicacoesBox.PrintPage>
                    <div style={{ textAlign: "center", paddingTop: "30px" }}><img src={LogoTce} alt="" /></div>
                    <div style={{ textAlign: "center", fontSize: "24px" }}><span>Tribunal de Contas do Estado de Goiás</span></div>
                    <div style={{ textAlign: "center", padding: "10px" }}><span>Comunicações {titulo}</span></div>
                    <div style={{ fontSize: "12px" }}>
                        <div style={{ display: "inline" }}>
                            <span>Usuário:</span>
                            <span style={{ paddingLeft: "5px" }}>{auth.user?.profile.name}</span>
                        </div>
                        <div style={{ display: "inline", float: "right" }}>
                            <span>Data:</span>
                            <span style={{ paddingLeft: "5px" }}>{isNullReturnHyphen(DateFormat(new Date()))}</span>
                        </div>
                    </div>
                    <ComunicacoesBox.PrintHeader>
                        <ComunicacoesBox.PrintColumn><span>Comunicação</span></ComunicacoesBox.PrintColumn>
                        <ComunicacoesBox.PrintColumn><span>Destinatário</span></ComunicacoesBox.PrintColumn>
                        <ComunicacoesBox.PrintColumn><span>Responsável</span></ComunicacoesBox.PrintColumn>
                        <ComunicacoesBox.PrintColumn><span>Processo</span></ComunicacoesBox.PrintColumn>
                        <ComunicacoesBox.PrintColumn><span>Assunto Processual</span></ComunicacoesBox.PrintColumn>
                        <ComunicacoesBox.PrintColumn><span>Unidade Emitente</span></ComunicacoesBox.PrintColumn>
                        <ComunicacoesBox.PrintColumn><span>Data Envio</span></ComunicacoesBox.PrintColumn>
                        <ComunicacoesBox.PrintColumn><span>Data Aceite</span></ComunicacoesBox.PrintColumn>
                        <ComunicacoesBox.PrintColumn><span>Exige Resposta?</span></ComunicacoesBox.PrintColumn>
                        <ComunicacoesBox.PrintColumn><span>Vencimento</span></ComunicacoesBox.PrintColumn>
                        {etapaComunicacao >= EnumEtapasComunicacao.PendenteTriagem && (<ComunicacoesBox.PrintColumn><span>Data Envio Última Resposta</span></ComunicacoesBox.PrintColumn>)}
                        {etapaComunicacao === EnumEtapasComunicacao.PendenteLiberacao && (<ComunicacoesBox.PrintColumn><span>Motivo Deliberação</span></ComunicacoesBox.PrintColumn>)}

                    </ComunicacoesBox.PrintHeader>
                    <ComunicacoesBox.PrintBody>
                        {comunicacoesPrint.length > 0 && comunicacoesPrint.map((comunicacao) => (
                            <ComunicacoesBox.PrintBodyLine>
                                <ComunicacoesBox.PrintColumn><span>{isNullReturnHyphen(comunicacao.tipoDocumento) + " nº " + isNullReturnHyphen(comunicacao.numeroDocumentoNaOrigem)}</span></ComunicacoesBox.PrintColumn>
                                <ComunicacoesBox.PrintColumn><span>{isNullReturnHyphen(comunicacao.nomeOrgaoJurisdicionado)}</span></ComunicacoesBox.PrintColumn>
                                <ComunicacoesBox.PrintColumn><span>{isNullReturnHyphen(comunicacao.nomePessoaResponsavel)}</span></ComunicacoesBox.PrintColumn>
                                <ComunicacoesBox.PrintColumn><span>{isNullReturnHyphen(comunicacao.numeroDoProcesso)}</span></ComunicacoesBox.PrintColumn>
                                <ComunicacoesBox.PrintColumn><span>{isNullReturnHyphen(comunicacao.assuntoProcessual)}</span></ComunicacoesBox.PrintColumn>
                                <ComunicacoesBox.PrintColumn><span>{isNullReturnHyphen(comunicacao.nomeUnidadeEmitente)}</span></ComunicacoesBox.PrintColumn>
                                <ComunicacoesBox.PrintColumn><span>{isNullReturnHyphen(DateFormat(comunicacao.dataEnvioComunicacao))}</span></ComunicacoesBox.PrintColumn>
                                <ComunicacoesBox.PrintColumn><span>{isNullReturnHyphen(DateFormat(comunicacao.dataAceite))}</span></ComunicacoesBox.PrintColumn>
                                <ComunicacoesBox.PrintColumn><span>{comunicacao.exigeResposta === 1 ? 'Sim' : 'Não'}</span></ComunicacoesBox.PrintColumn>
                                <ComunicacoesBox.PrintColumn><span>{isNullReturnHyphen(DateFormat(comunicacao.dataVencimentoPrazo))}</span></ComunicacoesBox.PrintColumn>
                                {etapaComunicacao >= EnumEtapasComunicacao.PendenteTriagem && (<ComunicacoesBox.PrintColumn><span>{isNullReturnHyphen(DateFormat(comunicacao.dataEnvioUltimaResposta))}</span></ComunicacoesBox.PrintColumn>)}
                                {etapaComunicacao === EnumEtapasComunicacao.PendenteLiberacao && (<ComunicacoesBox.PrintColumn><span>{isNullReturnHyphen(comunicacao.motivoDeliberacaoUltimaResposta)}</span></ComunicacoesBox.PrintColumn>)}
                            </ComunicacoesBox.PrintBodyLine>
                        ))
                        }
                    </ComunicacoesBox.PrintBody>
                </ComunicacoesBox.PrintPage >
            )
        }
    }

    return (
        <>
            {(comunicacoes.length > 0 || totalPagina > 1 || pagina > 1) && (
                <Paginacao
                    pagina={pagina}
                    qtdePagina={qtdePagina}
                    totalPagina={totalPagina}
                    setPagina={setPagina}
                    setQtdePagina={setQtdePagina}
                    exportaCsv={() => exportaCsv()}
                    exportPdf={() => exportPdf()}
                    loadingCsv={loadingCsv}
                    loadingPdf={loadingPdf}
                />
            )}

            {comunicacoes.length > 0 || totalPagina > 1 ? comunicacoes.map((comunicacao) => (
                <ComunicacaoBox
                    idOrgaoJurisdicionado={idOrgaoJurisdicionado}
                    comunicacao={comunicacao}
                    etapaComunicacao={etapaComunicacao}
                    setRecarregarComunicacoes={(value) => setRecarregarComunicacoes(value)}
                />
            )) : <p>Nenhuma comunicação para esse item.</p>
            }

            {(comunicacoes.length > 0 || totalPagina > 1 || pagina > 1) && (
                <Paginacao
                    pagina={pagina}
                    qtdePagina={qtdePagina}
                    totalPagina={totalPagina}
                    setPagina={setPagina}
                    setQtdePagina={setQtdePagina}
                    exportaCsv={() => exportaCsv()}
                    exportPdf={() => exportPdf()}
                    loadingCsv={loadingCsv}
                    loadingPdf={loadingPdf}
                />
            )}

            <div style={{ display: 'none' }}>
                <ComunicacaoPrint ref={componentRef} />
            </div>
        </>
    )
}